import config from '../config';
import Logger from '../logger';
import event from '../mixins/event';

class ThemeHeader {

	// Vars
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	/**
	 * Class constructor
	 */
	constructor(dom) {

		this.NAME = 'ThemeHeader';

		this.dom = dom;
		this.searchToggleDom = this.dom.querySelector(`[data-theme-header-search-toggle]`);

		this.searchDom = this.dom.querySelector(`[data-theme-header-search]`);
		this.searchActiveClass = `theme-header__search--active`;

		this.searchCloseOverlayDom = this.dom.querySelector(`[data-theme-header-search-close-overlay]`);
		this.searchCloseOverlayDomActiveClass = `theme-header__search-close-overlay--active`;
	}

	/**
	 * init - Initialize the header
	 */
	init() {
		Logger.info(`${this.NAME} > init`);
		this.initSearchToggleDom();
	}

	/**
	 * initSearchToggleDom - Initialize the search toggle
	 */
	initSearchToggleDom() {
		Logger.info(`${this.NAME} > initSearchToggleDom`);

		if (this.searchToggleDom) {
			this.searchToggleDom.addEventListener('click', (e) => {
				this.toggleSearch(e);
			});
		}

		if (this.searchCloseOverlayDom) {
			this.searchCloseOverlayDom.addEventListener('click', (e) => {
				this.toggleSearch(e);
			});
		}
	}

	/**
	 * toggleSearch - Toggle the search
	 */
	toggleSearch(e) {
		Logger.info(`${this.NAME} > toggleSearch`);
		e.preventDefault();

		// Toggle the search overlay
		this.searchCloseOverlayDom?.classList.toggle(this.searchCloseOverlayDomActiveClass);

		// Toggle the search
		this.searchDom?.classList.toggle(this.searchActiveClass);
		if (this.searchDom?.classList.contains(this.searchActiveClass)) {
			this.searchDom.querySelector('input')?.focus();
		}
		this.trigger('ThemeHeader:search_toggled', this.searchDom?.classList.contains(this.searchActiveClass));
	}
}

Object.assign(ThemeHeader.prototype, event);

export default ThemeHeader;
